import RSSerializableBase from 'lumen/serializers/rsserializable';

export default class RSStrategySerializer extends RSSerializableBase {}
